import { FileType } from "@/components/utils/uploadFile";
import type { BatchLimits, UploadLimits } from "@/components/utils/uploadBatch";

export const MAX_CUSTOM_ICONS = 60;

export const IMAGE_UPLOAD: UploadLimits = {
    allowedFileTypes: [FileType.Images],
    maxFileSize: 10,
};

export const VIDEO_UPLOAD: UploadLimits = {
    allowedFileTypes: [FileType.Video],
    maxFileSize: 100,
};

export const AUDIO_UPLOAD: UploadLimits = {
    allowedFileTypes: [FileType.Audio],
    maxFileSize: 50,
};

export const DOCUMENT_UPLOAD: UploadLimits = {
    allowedFileTypes: [
        FileType.PDF,
        FileType.Word,
        FileType.Excel,
        FileType.PowerPoint,
        FileType.Images,
    ],
    maxFileSize: 50,
};

export const ICON_UPLOAD: UploadLimits = {
    allowedFileTypes: [FileType.Images, FileType.SVG],
    maxFileSize: 2,
};

const libraryMaxByType: Partial<Record<FileType, number>> = {};
for (const kind of [IMAGE_UPLOAD, VIDEO_UPLOAD, AUDIO_UPLOAD, DOCUMENT_UPLOAD])
    for (const type of kind.allowedFileTypes)
        libraryMaxByType[type] ??= kind.maxFileSize;

export const MEDIA_LIBRARY_UPLOAD: BatchLimits = {
    allowedFileTypes: Object.keys(libraryMaxByType) as FileType[],
    maxFileSize: DOCUMENT_UPLOAD.maxFileSize,
    maxFileSizeByType: libraryMaxByType,
};
